import { render, staticRenderFns } from "./timeout-order.vue?vue&type=template&id=746accfe&scoped=true&"
import script from "./timeout-order.vue?vue&type=script&lang=js&"
export * from "./timeout-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746accfe",
  null
  
)

export default component.exports